import { create } from 'apisauce';
import config from './config.json';

const api = create({
  baseURL: config.backendUrl,
});

export default api;
